import { WorkIndex } from '../components/work/work-index';
import { absoluteUrl, defaultSocialImage } from '../content/metadata';

import { type Route } from './+types/work';

const description =
  'A mix of enterprise engagements and products Clinton Agada builds himself — from a BPMN 2.0 editor and AI assistant at ValueBlue to a zero-downtime healthcare migration and independent products.';

export const meta: Route.MetaFunction = () => [
  {
    title: 'Work - Clinton Agada',
  },
  {
    name: 'description',
    content: description,
  },
  {
    property: 'og:title',
    content: 'Work - Clinton Agada',
  },
  {
    property: 'og:description',
    content: description,
  },
  {
    property: 'og:url',
    content: absoluteUrl('/work'),
  },
  {
    property: 'og:image',
    content: defaultSocialImage,
  },
  {
    property: 'og:site_name',
    content: 'clintonagada.dev',
  },
  {
    name: 'twitter:title',
    content: 'Work - Clinton Agada',
  },
  {
    name: 'twitter:description',
    content: description,
  },
  {
    name: 'twitter:image',
    content: defaultSocialImage,
  },
  {
    tagName: 'link',
    rel: 'canonical',
    href: absoluteUrl('/work'),
  },
];

export default function WorkPage() {
  return <WorkIndex />;
}
